// src/docs/DocsConnectWallet.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsConnectWallet = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
      Wallet Connection      
      </Typography>
      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        To fully interact with CrowdLaunch, you need to connect your web3 injected wallet.
        This guide will walk you through the steps and important considerations for connecting your wallet securely.
      </Typography>
      
      {/* Why Connect Your Wallet */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why Connect Your Wallet?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Connecting your wallet allows you to access all features on CrowdLaunch including:
        <br />• Managing your shares and holdings.
        <br />• Participating in tokenized project sales.
        <br />• Staking LNCH for rewards.
        <br />• Verifying and managing your projects.
      </Typography>
      
      {/* Supported Wallets */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Supported Wallets
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        CrowdLaunch supports popular wallets such as MetaMask and TrustWallet. We recommend using MetaMask for the best experience. Ensure your wallet is updated to the latest version.
      </Typography>
      
      {/* How to Connect */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How to Connect Your Wallet
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Follow these steps to connect your wallet:
        <br />1. Install a supported wallet (e.g., MetaMask) in your browser or mobile device.
        <br />2. Create a new wallet or import an existing one using your seed phrase.
        <br />3. Ensure you are on the correct network (Smart Chain for LNCH).
        <br />4. Click the "Connect Wallet" button on CrowdLaunch.
        <br />5. Confirm the connection in your wallet interface.
      </Typography>
      
      {/* Security Considerations */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Security Considerations
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Your wallet connection is secure and private. CrowdLaunch only requests permission to view your wallet address and
        to perform transactions when you confirm them. Always verify that you are connecting via the official CrowdLaunch site.
      </Typography>
      
      {/* Troubleshooting */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Troubleshooting
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        If you experience issues while connecting your wallet:
        <br />• Try refreshing the page or reconnecting your wallet.
        <br />• Ensure your wallet extension is enabled and updated.
        <br />• Confirm that you are on the correct network.
        <br />• Check your wallet's notifications for any pending actions.
      </Typography>
      
      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By following these steps, you'll quickly connect your wallet to CrowdLaunch, unlocking all the platform's features.
        Always exercise caution and ensure your wallet's security.
      </Typography>
    </Container>
  );
};

export default DocsConnectWallet;
